import { eduIDApi } from "./common";
export const bankIDApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        bankIDVerifyIdentity: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-identity",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyIdentity" }),
                });
            },
            extraOptions: { service: "bankid" },
        }),
        bankIDMfaAuthenticate: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "mfa-authenticate",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "loginMfaAuthn" }),
                });
            },
            extraOptions: { service: "bankid" },
        }),
        bankIDVerifyCredential: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-credential",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyCredential" }),
                });
            },
            extraOptions: { service: "bankid" },
        }),
        bankIDGetStatus: builder.query({
            query: (body) => ({
                url: "get-status",
                body,
            }),
            extraOptions: { service: "bankid" },
        }),
        bankIDMfaRegister: builder.query({
            query: () => ({
                url: "mfa-register",
                body: {
                    method: "bankid",
                    frontend_action: "signupExternalMfa",
                },
            }),
            extraOptions: { service: "bankid" },
        }),
    }),
});
